<template>
    <!-- Error POpUp Slid Bottom -->
    <transition name="fade">
      <sidebar
        :isPanelOpen="isPanelOpenError"
        position="bottom"
        paddingTopBottom="paddingTopBottomHide"
        :panelHeight="customPanelHeight"
      >
        <section
            class="grid justify-items-center text-center gap-6 border-gray-200 px-6 py-2 mb-8 pt-4"
        >
          <div title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
          <div class="grid gap-4 justify-center justify-items-center w-full">
            <img src="../assets/mandate-failure.svg" alt="Error" width="119" height="115" />
            <p class>{{ errorMessage }}</p>
          </div>
        </section>
        <div class="grid gap-4 pb-6">
          <custom-button class="w-full" variant="primary" type="button" @click.prevent="retryErrorMessage()">Ok</custom-button>
        </div>
      </sidebar>
    </transition>
    <!-- GPay Request Permissions POP UP -->
    <transition name="fade">
      <sidebar
        :isPanelOpen="isPanelOpenMandate"
        @closeSidebarPanel="false"
        position="bottom"
        paddingTopBottom="paddingTopBottomHide"
        :panelHeight="customPanelHeight"
      >
        <section
            class="grid justify-items-center text-center gap-4 border-gray-200 px-6 py-2 mb-2 pt-4"
        >
          <div @click.prevent="false" title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
          <div>
            <h2 class="heading-text">Something went wrong!</h2>
            <p class="label-text-medium">Please try again</p>
          </div>
        </section>
        <div class="grid gap-4 pb-6">
          <custom-button class="w-full" variant="primary" type="button" @click.prevent="reTryRequestPermissions()">Retry</custom-button>
        </div>
      </sidebar>
    </transition>
    <!-- Spin Loader -->
    <spin-loader :spinLoading="isSpinLoading"/>
</template>
<script>
import { mapGetters } from 'vuex';
import Cookies from 'js-cookie';
import Sidebar from '../components/Sidebar.vue';
import CustomButton from '../components/CustomButton.vue';
import AutoTick from '../assets/animation/auto-tick.json';
import SpinLoader from '../components/spinLoader.vue';
import IdentifierMappings from '../components/IdentifierMappings.json';

export default {
  name: 'MobileNo',
  components: {
    CustomButton,
    SpinLoader,
    Sidebar
  },
  computed: {
    ...mapGetters(['microAppsUrlParams', 'errorCode']),
  },
  data() {
    return {
      isSpinLoading: undefined,
      errorMessage: undefined,
      isPanelOpenError: false,
      isModalOpen: false,
      isPanelOpenMandate: false,
      customPanelHeight: 'auto',
      isFocus: false,
      AutoTick,
      gPayAverageValue: undefined,
      paramsNotOnboardingJourney: {
        marketplaceInfo: {
          name: undefined,
          membershipId: undefined,
        },
        isOnboardingJourney: "false",
      },
      transactionAggregations: [
        {
            transactionDaysCountRange: {
                identifier: "lmjl"
            },
            dateRange: {
                endDate: {
                    month: 4,
                    year: 2023,
                    day: 30
                },
                startDate: {
                    month: 4,
                    year: 2023,
                    day: 1
                }
            },
            transactionAmountRange: {
                identifier: "owql"
            },
            transactionCountRange: {
                identifier: "mwib"
            },
            transactedUniqueUsersCountRange: {
                identifier: "nmal"
            }
        },
        {
            transactionDaysCountRange: {
                identifier: "lmjl"
            },
            dateRange: {
                endDate: {
                    month: 5,
                    year: 2023,
                    day: 31
                },
                startDate: {
                    month: 5,
                    year: 2023,
                    day: 1
                }
            },
            transactionAmountRange: {
                identifier: "owql"
            },
            transactionCountRange: {
                identifier: "mwib"
            },
            transactedUniqueUsersCountRange: {
                identifier: "nmal"
            }
        },
        {
            transactionDaysCountRange: {
                identifier: "lmjl"
            },
            dateRange: {
                endDate: {
                    month: 6,
                    year: 2023,
                    day: 30
                },
                startDate: {
                    month: 6,
                    year: 2023,
                    day: 1
                }
            },
            transactionAmountRange: {
                identifier: "owql"
            },
            transactionCountRange: {
                identifier: "mwib"
            },
            transactedUniqueUsersCountRange: {
                identifier: "nmal"
            }
        },
      ],
      params: {
        personalInfo: {
          firstName: undefined,
          lastName: undefined,
          email: undefined,
          phone: undefined,
          pan: undefined,
          emailVerified: undefined,
        },
        businessInfo: {
          name: undefined,
          entityType: undefined,
          pan: undefined,
          gstin: undefined,
          mcc: undefined,
            address: {
              pincode: undefined,
              line1: undefined,
              line2: undefined,
              city: undefined,
              state: undefined,
            },
        },
        marketplaceInfo: {
          name: undefined,
          membershipId: undefined,
          dateOfJoining: undefined
        },
        device: {
          deviceType: undefined,
          deviceMake: undefined,
          deviceModel: undefined,
          os: undefined,
          osVersion: undefined
        },
        location: {
          latitude: undefined,
          longitude: undefined,
        },
        isOnboardingJourney: "true",
      },
      location: {
        latitude: undefined,
        longitude: undefined,
      },
      phone: undefined,
      VueAppDevChangesServer: process.env.VUE_APP_ENV,
      checkDevActiveServer: process.env.VUE_APP_API_ROOT,
      isOpen: undefined,
      isCheckedGenericDev: undefined,
      isCheckedGenericDevFb1: undefined,
      isCheckedGenericPhase2: undefined,
      isCheckedGenericFb2: undefined,
      isCheckedGenericDevFb3: undefined,
      genericDevServerUrl: 'https://generic-dev.epaylater.in',
      GenericDevFb1ServerUrl: 'https://generic-dev-fb-1.epaylater.in',
      GenericPhase2ServerUrl: 'https://generic-dev-phase2.epaylater.in',
      GenericFb2ServerUrl: 'https://generic-dev-fb-2.epaylater.in',
      GenericDevFb3ServerUrl: 'https://generic-dev-fb-3.epaylater.in',
      hostname: window.location.hostname,
      isResetEnable: undefined,
      isMobile: false,
      isPhoneNumber: false,
      requestPermissionsCount: undefined,
      identityCount: 3,
      businessInfoCount: 3,
      businessRegistrationCount: 3,
      creditProfileCount: 3,
      reTryCount: 3,
      errorCodeStore: undefined,
      createApplicationCount: 3
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_INITIATED_CHECKED);
      this.isFocus = false;
      this.isMobile = window.innerWidth <= 768; // set the breakpoint for mobile devices
      // localhost
      localStorage.removeItem('phone');
      Cookies.remove('mobileNo');
      Cookies.remove('authToken');
      // serverSite
      Cookies.remove('mobileNo', { path: '/', domain: '.epaylater.in' });
      Cookies.remove('authToken', { path: '/', domain: '.epaylater.in' });
      // Redirect To on-boarding Or Normal
      if (this.microAppsUrlParams) {
        if (this.microAppsUrlParams.redirect === 'on-boarding' ||
          this.microAppsUrlParams.redirect === 'suppliers' ||
          this.microAppsUrlParams.redirect === 'transaction-list' ||
          this.microAppsUrlParams.redirect === 'transaction-details' ||
          this.microAppsUrlParams.redirect === 'on-boarding-testing' ||
          this.microAppsUrlParams.redirect === 'suppliers-testing' ||
          this.microAppsUrlParams.redirect === 'transaction-details-testing' ||
          this.microAppsUrlParams.redirect === 'transaction-list-testing'
        ) {
          this.isSpinLoading = true;
          this.$trackEvent(
            this.$mixpanelEvent.G_PAY_MICRO_APP_REDIRECTED_URL_PARAMS,
            this.$mixpanelPayload.reason = {
              url: this.microAppsUrlParams,
              status: true,
              res: 'get url param'
            }
          );
        } else {
          this.$trackEvent(
            this.$mixpanelEvent.G_PAY_MICRO_APP_REDIRECTED_URL_PARAMS,
            this.$mixpanelPayload.reason = {
              url: this.microAppsUrlParams,
              status: false,
              res: 'get different url Param'
            }
          );
        }
      } else {
        this.$trackEvent(
          this.$mixpanelEvent.G_PAY_MICRO_APP_REDIRECTED_URL_PARAMS,
          this.$mixpanelPayload.reason = {
            url: this.microAppsUrlParams,
            status: false,
            res: 'not get Url Param'
          }

        );
      }
      if (this.microAppsUrlParams.redirect === 'on-boarding') {
        console.log("Start Onboarding Journey Hitting getCurrentLocation and requestPermissions JavaScript Api");
        if (window.microapps === undefined) {
          window.location.reload();
        }
        this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_REDIRECTED_REQUEST_PERMISSIONS_INITIATED);
        this.requestPermissionsCount = 3;
        this.requestPermissions();
      } else if (this.microAppsUrlParams.redirect === 'on-boarding-testing') {
        if (this.microAppsUrlParams?.phone) {
          this.params.personalInfo.phone = this.microAppsUrlParams?.phone;
        }
        if (this.microAppsUrlParams?.pan) {
          this.params.personalInfo.pan = this.microAppsUrlParams?.pan;
        }
        if (this.microAppsUrlParams?.first_name) {
          this.params.personalInfo.firstName = this.microAppsUrlParams?.first_name;
        }
        if (this.microAppsUrlParams?.last_name) {
          this.params.personalInfo.lastName = this.microAppsUrlParams?.last_name;
        }
        if (this.microAppsUrlParams?.m_code) {
          this.params.marketplaceInfo.name = this.microAppsUrlParams.m_code.toLowerCase();
        }
        if (this.microAppsUrlParams?.bpan) {
          this.params.businessInfo.pan = this.microAppsUrlParams?.bpan;
        }
        if (this.microAppsUrlParams?.email) {
          this.params.personalInfo.email = this.microAppsUrlParams?.email;
        }
        this.deviceDetails();
        this.referralStartForGPayTest();
      } else {
        this.paramsNotOnboardingJourney.marketplaceInfo.name = this.microAppsUrlParams.m_code.toLowerCase();
        this.paramsNotOnboardingJourney.marketplaceInfo.membershipId = this.microAppsUrlParams.google_application_id;
        this.referralStartForGPayNonOnBoardingJourney();
      }
    },
    panelClose() {
      this.isPanelOpenMandate = false;
    },
    // G-Pay API
    reTryRequestPermissions() {
      this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_REDIRECTED_REQUEST_PERMISSIONS_PERSONAL_DETAILS_POPUP_RETRY);
      if (this.reTryCount > 0) {
        this.reTryCount -= 1;
        this.requestPermissions();
      } else {
        this.reTryCount = 3;
      }
    },
    requestPermissions() {
      this.isPanelOpenMandate = false;
      if (this.requestPermissionsCount > 0) {
        const request = {
          apiNames: ['getIdentity', 'getBusinessInfo', 'getBusinessRegistration', 'getCreditProfile'],
        };
        // requestPermissions
        window.microapps.merchant.requestPermissions(request)
          .then(response => {
            this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_REDIRECTED_REQUEST_PERMISSIONS_PERSONAL_DETAILS_POPUP_ALLOW);
            this.requestPermissionsCount = 3;
            console.log('requestPermissions response: ', response);

            // getIdentity
            const identityPromise = this.getIdentity();

            // getBusinessInfo
            const businessInfoPromise = this.getBusinessInfo();

            // getBusinessRegistration
            const businessRegistrationPromise = this.getBusinessRegistration();

            // getCreditProfile
            const creditProfilePromise = this.getCreditProfile();

            // Use Promise.all to wait for all promises to resolve
            return Promise?.all([identityPromise, businessInfoPromise, businessRegistrationPromise, creditProfilePromise])
              .then(([identityResult, businessInfoResult, businessRegistrationResult, creditProfileResult]) => {
                // Now all asynchronous operations have completed
                this.getCurrentLocation(identityResult, businessInfoResult, businessRegistrationResult, creditProfileResult);
            });
          })
          .catch(error => {
            this.errorCodeStore = error?.code;
            this.requestPermissionsCount -= 1;
            this.requestPermissions();
            this.isSpinLoading = false;
            console.error('requestPermissions API Failed: ', error);
            this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_REDIRECTED_REQUEST_PERMISSIONS_PERSONAL_DETAILS_POPUP_DENY);
          });
      } else {
        console.log();
        if (this.errorCodeStore === 7) {
          this.isSpinLoading = false;
          this.$router.push({
            name: 'Back To GPay',
            query: {
              message: 'Please grant consent to continue!'
            }
          });
        } else {
          this.$store.commit('updateMobileNoFocusBlur', true);
          this.isPanelOpenMandate = true;
          this.requestPermissionsCount = 3;
          this.isSpinLoading = false;
        }
      }
    },
    getCurrentLocation(identityResult, businessInfoResult, businessRegistrationResult, creditProfileResult) {
      // CurrentLocation
      window.microapps.getCurrentLocation().then(response => {
        this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_REDIRECTED_REQUEST_PERMISSIONS_LOCATION_POPUP_ALLOW);
        console.log('getCurrentLocation response: ', response);
        this.location.latitude = response.latitude;
        this.location.longitude = response.longitude;
        this.referralStartForGPay(identityResult, businessInfoResult, businessRegistrationResult, creditProfileResult);
      }).catch((err) => {
        this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_REDIRECTED_REQUEST_PERMISSIONS_LOCATION_POPUP_DENY);
        console.log(err, "getCurrentLocation Error");
        this.referralStartForGPay(identityResult, businessInfoResult, businessRegistrationResult, creditProfileResult);
      });
    },
    getIdentity() {
      let identityPromise;
      if (this.identityCount > 0) {
        const requestIdentity = { nonce: Date.now().toString(), skipPrompt: false };
        identityPromise = window.microapps.getIdentity(requestIdentity)
          .then(responseIdentity => {
            this.identityCount = 3;
            const decoded = JSON.parse(window.atob(responseIdentity.split('.')[1]));
            console.log('getIdentity response: ', decoded);
            return decoded;
          })
          .catch(error => {
            this.identityCount -= 1;
            this.getIdentity();
            console.error('getIdentity Failed: ', error);
          });
      } else {
        console.error('getIdentity Failed after 3 times');
        this.identityCount = 3;
      }
      return identityPromise;
    },
    getBusinessInfo() {
      let businessInfoPromise;
      if (this.businessInfoCount > 0) {
        const requestBusinessInfo = { nonce: Date.now().toString(), skipPrompt: true };
        businessInfoPromise = window.microapps.merchant.getBusinessInfo(requestBusinessInfo)
          .then(responseBusinessInfo => {
            this.businessInfoCount = 3;
            const decoded = JSON.parse(window.atob(responseBusinessInfo?.signedJwt.split('.')[1]));
            console.log('BusinessInfo response: ', decoded);
            return decoded;
          })
          .catch(error => {
            this.businessInfoCount -= 1;
            this.getBusinessInfo();
            console.error('BusinessInfo Failed: ', error);
          });
      } else {
        console.error('BusinessInfo Failed after 3 times');
        this.businessInfoCount = 3;
      }
      return businessInfoPromise;
    },
    getBusinessRegistration() {
      let businessRegistrationPromise;
      if (this.businessRegistrationCount > 0) {
        const requestBusinessRegistration = { nonce: Date.now().toString(), skipPrompt: false };
        businessRegistrationPromise = window.microapps.merchant.getBusinessRegistration(requestBusinessRegistration)
          .then(responseBusinessRegistration => {
            this.businessRegistrationCount = 3;
            const decoded = JSON.parse(window.atob(responseBusinessRegistration?.signedJwt.split('.')[1]));
            console.log('BusinessRegistration response: ', decoded);
            return decoded;
          })
          .catch(error => {
            this.businessRegistrationCount -= 1;
            this.getBusinessRegistration();
            console.error('BusinessRegistration Failed: ', error);
          });
      } else {
        console.error('BusinessInfo Failed after 3 times');
        this.businessRegistrationCount = 3;
      }
      return businessRegistrationPromise;
    },
    getCreditProfile() {
      let creditProfilePromise;
      if (this.creditProfileCount > 0) {
        const requestCreditProfile = { nonce: Date.now().toString(), skipPrompt: false };
        creditProfilePromise = window.microapps.merchant.getCreditProfile(requestCreditProfile)
          .then(responseCreditProfile => {
            this.creditProfileCount = 3;
            const decoded = JSON.parse(window.atob(responseCreditProfile?.signedJwt.split('.')[1]));
            console.log('CreditProfile response: ', decoded);
            return decoded;
          })
          .catch(error => {
            this.creditProfileCount -= 1;
            this.getCreditProfile();
            console.error('CreditProfile Failed: ', error);
          });
      } else {
        console.error('CreditProfile Failed after 3 times');
        this.creditProfileCount = 3;
      }
      return creditProfilePromise;
    },
    mapDataTransactionAggregations(creditProfileArrayList) {
      // Map data from transactionAggregations to transactionDetails
      const transactionDetails = [];
      if (creditProfileArrayList.length > 0) {
        creditProfileArrayList.forEach(aggregation => {
          transactionDetails.push({
            sales_month: new Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric' }).format(new Date(aggregation.dateRange.startDate.year, aggregation.dateRange.startDate.month, aggregation.dateRange.startDate.day)).replace(/\s/g, '-'), // Assuming you want the start date
            txn_count: this.mapIdentifier(aggregation.transactionCountRange.identifier, 'TransactionCount'),
            transacted_unique_users_count: this.mapIdentifier(aggregation.transactedUniqueUsersCountRange.identifier, 'TransactedUniqueUsersCount'),
            transaction_days_count: this.mapIdentifier(aggregation.transactionDaysCountRange.identifier, 'TransactionDaysCount'),
            net_sales_value: this.mapIdentifier(aggregation.transactionAmountRange.identifier, 'TransactionAmount')
          });
        });
      }
      return transactionDetails;
    },
    mapIdentifier(catchValue, mapping) {
      const mappingType = IdentifierMappings[mapping];
        const matchingKey = Object.keys(mappingType).find(key => mappingType[key] === catchValue);
        if (matchingKey) {
            const rangeValues = matchingKey.match(/\[(\d+),/);
            if (rangeValues) {
              return parseInt(rangeValues[1], 10);
            }
        }
        // If catchValue is not found in mappingType, assume it's already a numeric value
        return null;
    },
    createApplication(res, SessionId) {
      this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_CREATE_APPLICATION_METHOD_IN, {
        [this.$mixpanelPayload.KEY_MESSAGE]: `Parameters: result:- ${res}, sessionID: ${SessionId}`,
      });
      if (this.createApplicationCount > 0) {
        const request = { nonce: Date.now().toString(), partnerApplicationReferenceId: res?.applicationId };
        window.microapps.merchant.loan.createApplication(request).then(response => {
          console.log("Create Application Response: ", response);
          this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_CREATE_APPLICATION_SUCCESS);
          this.createApplicationCount = 3;
          const decoded = JSON.parse(window.atob(response?.signedJwt.split('.')[1]));
          console.log("Create Application Decoded Response: ", decoded);
          this.applicationMarketplaceMemberships(decoded?.googleApplicationId, res, SessionId);
        }).catch(error => {
          this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_CREATE_APPLICATION_FAILURE);
          this.createApplicationCount -= 1;
          this.createApplication();
          console.error('An error occurredOkk: ', error);
        });
      } else {
        this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_CREATE_APPLICATION_METHOD_COUNT, {
          [this.$mixpanelPayload.KEY_MESSAGE]: `Count: ${this.createApplicationCount}`,
        });
        this.createApplicationCount = 3;
      }
    },
    referralStartForGPayNonOnBoardingJourney() {
      const formData = new FormData();
      formData.append('data', JSON.stringify(this.paramsNotOnboardingJourney));
        this.$store
          .dispatch('referralStartForGPay', {
            formData
          })
          .then((response) => {
            const base64Url = response?.accessToken.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(window.atob(base64).split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
            const SessionId = JSON.parse(jsonPayload).sessionId;
            this.$store.commit('CREATE_SESSION', { SessionId });
              if (response?.tokenId) {
                this.$router.push({
                  name: 'Verify Otp',
                  query: {
                    ...this.$route.query,
                    session: SessionId,
                    phone: response?.phoneNumber
                  },
                });
              } else {
                this.createApplication(response, SessionId);
              }
          })
          .catch((err) => {
            this.$store.commit('updateMobileNoFocusBlur', true);
            this.errorMessage = err.message;
            this.isPanelOpenError = true;
            this.isSpinLoading = false;
          });
    },
    referralStartForGPay(identityResult, businessInfoResult, businessRegistrationResult, creditProfileResult) {
      this.$registerProperties({
        platform: 'web',
        m_code: 'gpay',
        gpay_unique_id: businessInfoResult?.businessInfo?.businessId
      });
      this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_REFERRAL_START_INITIATED);
      const valuePass = {
        params: {
          personalInfo: {
            firstName: businessInfoResult?.businessInfo?.businessOwnerName,
            email: identityResult?.email,
            phone: businessInfoResult?.businessInfo?.phoneNumber?.replace(/\+91-/g, ''),
            pan: businessRegistrationResult?.businessRegistration?.registeredPan,
            emailVerified: identityResult?.email_verified,
          },
          businessInfo: {
            name: businessInfoResult?.businessInfo?.businessRegisteredName,
            entityType: this.getEntityType(businessInfoResult),
            pan: businessRegistrationResult?.businessRegistration?.registeredPan,
            gstin: businessRegistrationResult?.businessRegistration?.gst,
              address: {
                pincode: businessInfoResult?.businessInfo?.businessAddress?.postalCodeNumber,
                line1: businessInfoResult?.businessInfo?.businessAddress?.addressLine[0],
                line2: businessInfoResult?.businessInfo?.businessAddress?.addressLine[1],
                city: businessInfoResult?.businessInfo?.businessAddress?.localityName,
                state: businessInfoResult?.businessInfo?.businessAddress?.administrativeAreaName,
              },
          },
          marketplaceInfo: {
            name: this.microAppsUrlParams.m_code.toLowerCase(),
            membershipId: businessInfoResult?.businessInfo?.businessId, // 9486361118
            dateOfJoining: (`01-${creditProfileResult?.creditProfile?.gpayOnboardingMonth}`).split('-').reverse().join('-')
          },
          device: {
            deviceType: this.getDeviceType(),
            deviceMake: this.getDeviceMake(),
            deviceModel: this.getDeviceModel(),
            os: this.getOS(),
            osVersion: this.getOSVersion()
          },
          transactionDetails: this.mapDataTransactionAggregations(creditProfileResult?.creditProfile?.transactionAggregations),
          location: {
            latitude: this.location.latitude,
            longitude: this.location.longitude,
          },
          mcc: businessInfoResult?.businessInfo?.mcc,
          isOnboardingJourney: "true",
        },
      };
      if (businessInfoResult?.businessInfo?.phoneNumber?.replace(/\+91-/g, '')) {
        // 4 on Condition call !tokenId redirect to next screen else call gPay Api CreateApplication
        const formData = new FormData();
        formData.append('data', JSON.stringify(valuePass.params));
        this.$store
          .dispatch('referralStartForGPay', {
            formData
          })
          .then((response) => {
            this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_REFERRAL_START_API_SUCCESS);
            const base64Url = response?.accessToken.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(window.atob(base64).split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
            const SessionId = JSON.parse(jsonPayload).sessionId;
            this.$store.commit('CREATE_SESSION', { SessionId });
              if (response?.tokenId) {
                this.$router.push({
                  name: 'Verify Otp',
                  query: {
                    ...this.$route.query,
                    session: SessionId,
                    phone: response?.phoneNumber
                  },
                });
              } else {
                this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_REFERRAL_START_API_NO_TOKEN);
                this.createApplication(response, SessionId);
              }
          })
          .catch((err) => {
            this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_REFERRAL_START_API_FAILURE, {
              [this.$mixpanelPayload.ERROR_REASON]: err.message,
              [this.$mixpanelPayload.ERROR_CODE]: this.errorCode
            });
            this.$store.commit('updateMobileNoFocusBlur', true);
            this.errorMessage = err.message;
            this.isPanelOpenError = true;
            this.isSpinLoading = false;
          });
      } else {
        this.$router.push({
            name: 'Back To GPay',
            query: {
              message: 'Something went wrong! Please contact ePaylater support at support@epaylater.in'
            }
        });
      }
    },
    getEntityType(businessInfoResult) {
      const registrationType = businessInfoResult?.businessInfo?.businessRegistrationType?.type;
      switch (registrationType) {
        case 'PRIVATE_LIMITED_COMPANY':
          return 'Private Limited';
        case 'PUBLIC_LIMITED_COMPANY':
          return 'Public Limited Company';
        case 'GOVERNMENT_UNDERTAKING':
          return 'Government Entity';
        case 'HINDU_UNDIVIDED_FAMILY':
          return 'Hindu Undivided Family';
        case 'LIMITED_LIABILITY_PARTNERSHIP':
          return 'Limited Liability Partnership';
        case 'PARTNERSHIP':
          return 'Partnership';
        case 'SOLE_PROPRIETORSHIP':
          return 'Proprietorship';
        case 'TRUST':
          return 'Trust';
        default:
          return 'Others';
      }
    },
    referralStartForGPayTest() {
      // 4 on Condition call !tokenId redirect to next screen else call gPay Api CreateApplication
      const formData = new FormData();
      formData.append('data', JSON.stringify(this.params));
      this.$store
        .dispatch('referralStartForGPay', {
          formData
        })
        .then((response) => {
          const base64Url = response?.accessToken.split('.')[1];
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const jsonPayload = decodeURIComponent(window.atob(base64).split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
          const SessionId = JSON.parse(jsonPayload).sessionId;
          this.$store.commit('CREATE_SESSION', { SessionId });
            if (response?.tokenId) {
              this.$router.push({
                name: 'Verify Otp',
                query: {
                  ...this.$route.query,
                  session: SessionId,
                  phone: response?.phoneNumber
                },
              });
            } else {
              this.createApplication(response, SessionId);
            }
        })
        .catch((err) => {
          this.$store.commit('updateMobileNoFocusBlur', true);
          this.errorMessage = err.message;
          this.isPanelOpenError = true;
          this.isSpinLoading = false;
        });
    },
    applicationMarketplaceMemberships(googleApplicationId, response, SessionId) {
      this.$registerProperties({
        platform: 'web',
        m_code: 'gpay',
        gpay_unique_id: googleApplicationId
      });
      this.$store
        .dispatch('applicationMarketplaceMemberships', response?.applicationId)
        .then((result) => {
          this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_MARKETPLACE_MAPPING_SUCCESS);
          const marketplaceId = result?.marketplaceMembershipStoreInfo[0]?.marketplaceId;
          this.gPayMarketplaceDocument(googleApplicationId, marketplaceId, response, SessionId);
        })
        .catch((err) => {
          this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_MARKETPLACE_MAPPING_FAILURE, {
            [this.$mixpanelPayload.ERROR_REASON]: err.message,
            [this.$mixpanelPayload.ERROR_CODE]: this.errorCode
          });
          this.$store.commit('updateMobileNoFocusBlur', true);
          this.errorMessage = err.message;
          this.isPanelOpenError = true;
          this.isSpinLoading = false;
        });
    },
    gPayMarketplaceDocument(googleApplicationId, marketplaceId, response, SessionId) {
      const params = {
        marketplace: {
          id: marketplaceId,
          membershipId: googleApplicationId
        }
      };
      const formData = new FormData();
      formData.append('jsonPayload', JSON.stringify(params));
      this.$store
        .dispatch('gPayMarketplaceDocument', {
          formData,
          applicationId: response?.applicationId,
          urlParams: {
            isToken: true,
            review: true,
            action: 'add',
          },
        })
        .then(() => {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_MARKETPLACE_DOCUMENT_SUCCESS);
          this.$router.push({
            name: 'Verify Otp',
            query: {
              ...this.$route.query,
              session: SessionId,
              phone: response?.phoneNumber
            },
          });
        })
        .catch((err) => {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_MARKETPLACE_DOCUMENT_FAILURE, {
            [this.$mixpanelPayload.ERROR_REASON]: err.message,
            [this.$mixpanelPayload.ERROR_CODE]: this.errorCode
          });
          this.$store.commit('updateMobileNoFocusBlur', true);
          this.errorMessage = err.message;
          this.isPanelOpenError = true;
          this.isSpinLoading = false;
        });
    },
    retryErrorMessage() {
      this.init();
      this.isPanelOpenError = false;
      this.errorMessage = undefined;
    },
    getDeviceType() {
      const screenWidth = window.innerWidth;

      switch (true) {
        case screenWidth < 600:
          return 'mobile';
        case screenWidth >= 600 && screenWidth < 1024:
          return 'tablet';
        default:
          return 'desktop';
      }
    },
    getDeviceMake() {
      // This is just an example, and it might not be accurate
      switch (true) {
        case /iPhone/i.test(navigator.userAgent):
          return 'Apple';
        case /Samsung/i.test(navigator.userAgent):
          return 'Samsung';
        default:
          return 'Unknown';
      }
    },
    getDeviceModel() {
      // Example logic to extract device model for specific cases
      if (/iPhone/i.test(navigator.userAgent)) {
        return 'iPhone';
      }

      if (/Samsung/i.test(navigator.userAgent)) {
        const samsungModelMatch = navigator.userAgent.match(/Samsung ([\w\s]+)/);
        return samsungModelMatch ? samsungModelMatch[1] : 'Samsung Device';
      }

      if (/iPad/i.test(navigator.userAgent)) {
        return 'iPad';
      }

      if (/Windows Phone/i.test(navigator.userAgent)) {
        const windowsPhoneMatch = navigator.userAgent.match(/Windows Phone ([\w\s.]+)/);
        return windowsPhoneMatch ? windowsPhoneMatch[1] : 'Windows Phone';
      }
      // Add more conditions for other devices
      return 'Unknown';
    },
    getOS() {
      switch (true) {
        case /Android/i.test(navigator.userAgent):
          return 'Android';
        case /iPhone|iPad|iPod/i.test(navigator.userAgent):
          return 'iOS';
        case /Windows/i.test(navigator.userAgent):
          return 'Windows';
        case /Mac OS/i.test(navigator.userAgent):
          return 'macOS';
        case /Linux/i.test(navigator.userAgent):
          return 'Linux';
        default:
          return 'Unknown';
      }
    },
    getOSVersion() {
      if (/Android/i.test(navigator.userAgent)) {
        const match = navigator.userAgent.match(/Android\s([0-9.]+)/);
        return match ? match[1] : 'Unknown';
      }

      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        const match = navigator.userAgent.match(/OS\s([0-9_]+)/);
        return match ? match[1].replace(/_/g, '.') : 'Unknown';
      }

      return 'Unknown';
    },
    deviceDetails() { // for dev
      this.params.device.os = this.getOS();
      this.params.device.osVersion = this.getOSVersion();
      this.params.device.deviceType = this.getDeviceType();
      this.params.device.deviceMake = this.getDeviceMake();
      this.params.device.deviceModel = this.getDeviceModel();
    },
  },
};
</script>
<style scoped>
.headingText{
  color: #4D4D4D 80%;
  font-family: 'Myriad Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
}
</style>
